import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GLOBAL_CONFIG } from '../../data/globalConfig';
import { EventSourcePolyfill } from 'event-source-polyfill';
import { LogMessage } from '../../models/infrastructure/LogMessage.model';
interface StreamData {
  data: string;
}

@Injectable({
  providedIn: 'root',
})
export class RxService {
  private endpointLogsStream = GLOBAL_CONFIG.config.backendHost + '/infra/container-logs/stream';
  private accessToken: string = "";
   
  constructor() { }

  saveToken(accessToken: string) {
    this.accessToken = accessToken;
  }

  getLogMessagesStream(): Observable<LogMessage> {
    return new Observable<LogMessage>(obs => {
      const es = new EventSourcePolyfill(this.endpointLogsStream, { headers: { 'Authorization': 'Bearer ' + this.accessToken }});
      
      es.addEventListener('message', (evt: StreamData) => {
        obs.next(evt.data != null ? JSON.parse(evt.data) : evt.data);
      });
      es.addEventListener('error', (error) => {
        if(es.readyState === 0) {
          console.log('The stream has been closed by the server.');
          es.close();
          obs.complete();
        } else {
          obs.error('EventSource error: ' + error);
        }
      });
      // return () => es.close();
    });
  }

 }
